// components/invisalign/InvisalignHero.tsx
"use client";

import React from "react";
import Hero from "@/components/tools/Hero";
import Link from "next/link";

const InvisalignHero: React.FC = () => {
  return (
    <>
      <Hero
        imageSrc="/images/Photo of smiling woman holding aligner for Invisalign Astoria NY treatment.jpg"
        imageAlt="Photo of smiling woman holding aligner for Invisalign Astoria NY treatment"
        title="Invisalign in Astoria NY"
        subtitle="Expert Clear Aligner Treatment with Personalized Care"
        ctaText="Schedule a Consultation"
        ctaLink="/contact"
      />

      {/* Introduction Content */}
      <section className="w-full py-10 bg-gradient-to-b from-white to-gray-50">
        <div className="max-w-6xl mx-auto px-4 space-y-6">
          <p className="text-lg leading-relaxed text-gray-700">
            Invisalign in Astoria is available right now at Smile4Me Dental
            Care, where{" "}
            <Link
              href="https://smile4mecare.com/meet-your-dentist/"
              className="inline-block bg-gradient-to-r from-[#AE7D2F] via-[#ECD05B] to-[#AE7D2F] bg-clip-text text-transparent hover:underline transition-all duration-300 ease-in-out"
            >
              Dr. Iosif Khaimov
            </Link>{" "}
            builds a custom-fit aligner plan around your specific smile instead
            of a one-size-fits-all mold. Skip the metal brackets and wires;
            clear, removable aligners let you eat, brush, and go about your day
            without anyone noticing you&apos;re in treatment. Book a consultation,
            and we&apos;ll scan your teeth, map out your timeline, and walk you
            through financing before you leave the office.
          </p>
        </div>
      </section>
    </>
  );
};

export default InvisalignHero;
